const RAW_API_BASE = (import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000').trim()

function getMediaBaseUrl() {
  return RAW_API_BASE.replace(/\/+$/, '')
}

const MEDIA_BASE_URL = getMediaBaseUrl()

export function resolveMediaUrl(rawPath) {
  const normalized = String(rawPath || '').trim().replaceAll('\\', '/')
  if (!normalized) return ''

  // Always force /media/ paths to use the correct API proxy, 
  // even if the backend accidentally sends http://127.0.0.1:8000
  const mediaIndex = normalized.toLowerCase().indexOf('/media/')
  if (mediaIndex >= 0) {
    return `${MEDIA_BASE_URL}${normalized.slice(mediaIndex)}`
  }

  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    return normalized
  }

  if (/^[a-zA-Z]:\//.test(normalized)) {
    return ''
  }

  if (normalized.startsWith('/')) {
    return `${MEDIA_BASE_URL}${normalized}`
  }

  return `${MEDIA_BASE_URL}/${normalized}`
}

